exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkboxActive {\r\n    float: right;\r\n    min-width: 290px;\r\n}\r\n\r\n.checkboxActive label {\r\n    padding-left: 7px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user-web-ios/user-web-ios.component.css
// module id = ../../../../../src/app/_components/user-web-ios/user-web-ios.component.css
// module chunks = main